import React from "react"
import { Link } from 'react-router-dom';
import {List} from 'antd';


import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram'


const FollowUs = () => {
    return (
                <div>
                    <h3 className="footer-title">Follow Us</h3>
                    <List>
                        <List.Item>
                            <Link to="/"><FacebookOutlinedIcon sx={{ fontSize: 18 }} /></Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/"><LinkedInIcon sx={{ fontSize: 18 }} /></Link>
                        </List.Item>
                        <List.Item>
                            <Link to="/"><InstagramIcon sx={{ fontSize: 18 }} /></Link>
                        </List.Item>
                    </List>
                </div>
    );
  }
  
  export default FollowUs;